define([
	'jquery',
	'pubsub',
	'Handlebars',
	'handlebars-core',
	], function($, pubsub, Handlebars, handlebarsCore) {

		/**
		*
		*	Base Auto Complete Plugin - Extends Handlebars Core - can be extended for features using autocomplete
		*
		*/

		'use strict';

		// OPTIONS SCHEMA
		// var searchAutoCompleteOptions = {
		// 	action : 'append',
		// 	template : 'html.autocomplete.base',
		// 	minLength : 3,
		// 	delay : 250,
		// 	searchQueryParam: "term'",
		// 	loadParameters : {
		// 		target : '.search-input-js',
		// 		pluginFN : 'autoComplete',
		// 		requireModule : 'autocomplete.base'
		// 	}
		// };

		var DEBUG = false,
			PLUGIN_IDENTIFIER = 'autoComplete';

		if ( DEBUG ) console.log('autoComplete file loaded');

		var	autoComplete = function( element, options ) {

			this.pluginID = PLUGIN_IDENTIFIER;

			this.element = element;

			this.$element = $(this.element);

			this.$resultsContainer = $(options.resultsContainer) || $('<div>');

			this.options = options || {};

			this.metadata = $(this.element).data('options');

		};

		autoComplete.prototype = {

			defaults : {
				action: 'html',
				minLength: 3,
				delay: 300,
				searchQueryParam: 'term'
			},

			// overwriting core init ()
			init : function () {

				if ( DEBUG ) console.log('Initializing ' + this.pluginID);

				var self = this;

				self.config = $.extend( true, {}, self.defaults, self.options, self.metadata );

				if ( DEBUG ) console.log('init, configuration : ', self.config);

				this.build();
				// async - get the template loaded and compiled, then set to object property, and bind events
				self.loadAndCompileTemplate().done(function(){
					self.events();
				});

				return self;

			},

			build : function () {

				if ( DEBUG ) console.log('build');

			},

			events : function () {

				if ( DEBUG ) console.log('events');

				var self = this;

				self.$element.on('keyup', function(event){
					self.handleKeyUp(event);
				});

			},

			handleKeyUp : function (event) {

				if ( DEBUG ) console.log('handleKeyUp');

				var self = this,
					value = $(event.target).val();

					if ( DEBUG ) console.log('value : ', value);

				clearTimeout(self.autoCompleteTimer);

				self.autoCompleteTimer = setTimeout(function(){

					if ( value.split('').length >= self.config.minLength ) {
						self.fetchData( value );
					} else {
						self.clearDisplay();
					}

				}, self.config.delay );

			},

			clearDisplay : function () {

				if ( DEBUG ) console.log('clearDisplay');

				this.$resultsContainer.html('');
			},

			// overwriting core fetch
			fetchData : function (term) {

				if ( DEBUG ) console.log('autoComplete fetchData');

				var self = this;

				// setting term for ajax call
				self.config.ajaxParams.data[self.config.searchQueryParam] = term;

				$.ajax(self.config.ajaxParams).done(function(data){

					// add term to data object for later use
					data.term = term;

					// call render directly
					self.render(data);

				}).fail(function(){

					if ( DEBUG ) {
						console.warn('AJAX Failed : ');
						$(arguments).each(function(){
							console.warn(this);
						});
					}

				});

			},

			// overwriting core render for autocomplete
			render : function (data) {

				if ( DEBUG ) console.log('autoComplete render, data : ', data );

				var self = this;

				this.$resultsContainer[self.config.action]( self.compiledTemplate(data) );

			}

		};

		autoComplete.defaults = autoComplete.prototype.defaults;

		autoComplete.prototype = $.extend({}, handlebarsCore, autoComplete.prototype);

		// prevent duplicate instantiation
		$.fn.autoComplete = function(options) {
			return this.each(function() {
				var instance = $(this).data(PLUGIN_IDENTIFIER);
				if(!instance) {
					instance = new autoComplete(this, options).init();
					$(this).data(PLUGIN_IDENTIFIER,instance);
				}
			});
		};

		return autoComplete;
	}
);